import { useRef, useState } from 'react'

import returnPackageIcon from '../../imgs/pc-actions/return-package-icon.svg'
import returnDisabledIcon from '../../imgs/pc-actions/return-package-icon-disabled.svg'
import Tooltip from '../Tooltip'

export const returnButtonTexts = {
  default: 'החזרת חבילה',
  disabled: 'החזרת חבילה',
  active: 'בקשתך בטיפול',
  tooltipTitle: 'בקשה בטיפול',
  tooltipDescription: 'לא ניתן לשלוח בקשה להחזרה כרגע',
  activeTooltipTitle: 'בקשתך בטיפול',
  activeTooltipDescription: 'לביטול הבקשה אנא פנה לשירות לקוחות',
  cancel: 'ביטול החזרה',
}
export const ReturnButton = ({ item, onReturnRequest, onCancelReturnRequest, texts = returnButtonTexts }) => {
  const [visibleTooltip, setVisibleTooltip] = useState(false)
  const returnIconRef = useRef(null)

  const createTooltipCloser = isOpen => {
    if (!isOpen) {
      setVisibleTooltip(false)
    }
  }
  // Disabled - other requests active
  if (item.isPaid || item.isShipped || item.isForUnite || item.isShrinkRequestActive || item.isPhotoRequestActive) {
    return (
      <>
        <button className='tool-cont' onClick={() => setVisibleTooltip(true)}>
          <div className='tool-cont-img-bcg' ref={returnIconRef}>
            <img src={returnDisabledIcon} alt='Return package disabled' />
          </div>
          <span>{texts.disabled}</span>
        </button>
        <Tooltip
          title={texts.tooltipTitle}
          description={texts.tooltipDescription}
          isTooltipOpen={visibleTooltip}
          setIsTooltipOpen={createTooltipCloser}
          triggerRef={returnIconRef}
        />
      </>
    )
  }

  // Default - can request return
  if (!item.isReturnRequestActive) {
    return (
      <button className='tool-cont' onClick={onReturnRequest}>
        <div className='tool-cont-img-bcg'>
          <img src={returnPackageIcon} alt='Return package' />
        </div>
        <span>{texts.default}</span>
      </button>
    )
  }
  const isCancelPossible = !!onCancelReturnRequest
  // Return request active - show disabled with tooltip
  if (item.isReturnRequestActive) {
    return (
      <>
        <button className='tool-cont' onClick={onCancelReturnRequest || (() => setVisibleTooltip(true))}>
          <div className='tool-cont-img-bcg' ref={returnIconRef}>
            <img src={isCancelPossible ? returnPackageIcon : returnDisabledIcon} alt='Return request active' />
          </div>
          <span style={{ color: isCancelPossible ? 'red' : '' }}>{isCancelPossible ? texts.cancel : texts.active}</span>
        </button>
        <Tooltip
          title={texts.activeTooltipTitle}
          description={texts.activeTooltipDescription}
          isTooltipOpen={visibleTooltip}
          setIsTooltipOpen={createTooltipCloser}
          triggerRef={returnIconRef}
        />
      </>
    )
  }

  return null
}
